<template lang="pug">
  div 
    v-container(fluid grid-list-lg v-if="items")
      
      v-layout.py-4(row wrap)
        v-flex(xs12 sm6)
          div.display-1 Select your items
        v-flex(xs12 sm6)
          v-text-field(v-model="search" label="Search") Search
        v-flex(xs12)
          v-btn.text-xs-center(@click="drawer = true") Select Category 
          span(v-if="selectedCategory!=''") Current Category: {{selectedCategory}} 
            v-btn(@click="selectedCategory = ''" icon) 
              v-icon close
          span(v-else) Showing all items
      v-divider
      v-navigation-drawer(
        v-model="drawer"
        app
        :touchless="true" :disable-resize-watcher="true"
        )
        v-list
          v-list-tile 
            v-list-tile-content 
              v-btn(icon @click="drawer=false")
                v-icon close
        v-layout.pa-2(column)
          v-flex.title() Categories
          categories(@setCategory='setCategory') 
        
      v-layout.py-4(row wrap )
        v-flex(v-for="item in items" xs12 sm6 md4 lg3)
          item.ma-1( :item="item" )

</template>
<script>
// Shows all the available events for users to choose
import Categories from '../components/Categories'
import Item from "../components/Item"
export default {
  name:'items',
  data:()=>({
    drawer: false,
    search:'',
    selectedCategory:''
    //events: [1, 2]
  }),
  components: {Item, Categories},
  computed:{
    items(){
      let items = []
      items = this.$store.state.items
      let filteredItems = null
      if (this.selectedCategory!='' && items.length > 0){
        filteredItems = items.filter(i=>{
          let flag = false
          if (this.search.trim().toUpperCase()!=''){
            console.log('Category: '+ i.category.toUpperCase().includes(this.selectedCategory.toUpperCase())  ,"search:"+ i.itemName +i.itemName.toUpperCase().includes(this.search.trim().toUpperCase() ))
            if(i.category.toUpperCase().includes(this.selectedCategory.toUpperCase()) && i.itemName.toUpperCase().includes(this.search.trim().toUpperCase() )){
              return true
            }
          }else{
            if(i.category.toUpperCase().includes( this.selectedCategory.toUpperCase() )){
              return true
            }
          }
        })
        return filteredItems
      }else{
        if (this.search.trim()!=''){
          return items.filter(i=>{
            return i.itemName.toUpperCase().includes(this.search.trim().toUpperCase())
          })
        }else {
          return items
        }
      }
       
    }
  },
  methods:{
    openItem(item){
      console.log(item)
    },
    setCategory(name){
      this.drawer= false
      this.selectedCategory = name
    }
  }
}
</script>


